module.exports = __webpack_public_path__ + "static/media/empty-seats.cb61ac4f.svg";